@if (showSpinner) {
  <div fxFill fxLayoutAlign="center center">
    <mat-spinner></mat-spinner>
  </div>
}
@for (resource of resources; track resource) {
  <mat-card class="lesson-card">
    <mat-card-header>
      <mat-card-title
            [ngClass]="{
                'assignment' : assignmentsListId.includes(resource.id)
            }">{{resource.attributes.metadatas.title}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-progress-bar mode="determinate" [value]="pourcent(resource.id)"></mat-progress-bar>
      @if (getAssignmentAssignatorName(resource.id)!=='') {
        <div class="assign_comment">
          <b>{{getAssignmentAssignatorName(resource.id)}} @if (notAutoAssignation(resource.id)) {
            <span>{{ 'assign.lesson_to_you'| translate}}</span>
          } </b>
          @if (getAssignmentComment(resource.id)!=='') {
            <span>{{getAssignmentComment(resource.id)}}</span>
          }
        </div>
      }
    </mat-card-content>
    <mat-card-actions>
      <button role="button" [attr.data-e2e]="'btn_launch_modal' + resource.id"
                (click)="
                    launchModal(
                        resource,
                        assignmentsListId.includes(resource.id),
                        autoAssignmentsListId.includes(resource.id),
                        closedAssignmentsListId.includes(resource.id))
                ">
        <mat-icon aria-hidden="true" svgIcon="lessonCardIcon"></mat-icon>
        <span>{{ 'activities.explore' | translate}}</span>
      </button>
    </mat-card-actions>
  </mat-card>
}